export const daysOfWeek = [
  {
    label: "شنبه",
    key: "Saturday",
  },
  {
    label: "یکشنبه",
    key: "Sunday",
  },
  {
    label: "دوشنبه",
    key: "Monday",
  },
  {
    label: "سه شنبه",
    key: "Tuesday",
  },
  {
    label: "چهار شنبه",
    key: "Wednesday",
  },
  {
    label: "جمعه",
    key: "Friday",
  },
  {
    label: "پنجشنبه",
    key: "Thursday",
  },
];
export const prices = [
  {
    label: "توافقی",
    key: "deal",
    api: {
      deal: true,
    },
  },
  {
    label: "کمتر از ۲ میلیون",
    key: "1-2",
    api: {
      max_price: 2000000,
    },
  },
  {
    label: "بین 2 تا 5 میلیون",
    key: "2-5",
    api: {
      min_price: 2000000,
      max_price: 5000000,
    },
  },
  {
    label: "بین 5 تا 20 میلیون",
    key: "5-20",
    api: {
      min_price: 5000000,
      max_price: 20000000,
    },
  },
  {
    label: "بین 20 تا 50 میلیون",
    key: "20-50",
    api: {
      min_price: 20000000,
      max_price: 50000000,
    },
  },

  {
    label: "بین 50 تا 100 میلیون",
    key: "50-100",
    api: {
      min_price: 50000000,
      max_price: 100000000,
    },
  },
  {
    label: "100 میلیون به بالاتر",
    key: "100",
    api: {
      min_price: 100000000,
    },
  },
];
